import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Router from "next/router";
import dynamic from "next/dynamic";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Button,
  AppBar,
  Toolbar,
  MenuItem,
  IconButton
} from "@material-ui/core";

import IconText from "../IconText";
import Logo from "./Logo";
import { logout } from "../../containers/Login/rolesActions";
import { sendAppLink, giveFeedback } from "./headerActions";
import {
  detectMobile,
  recruiterToSeekerUTM,
  getFirstWord,
  allowSendAppLink
} from "../../services/utils";
import { RECRUITER_ANDROID_APP } from "../../services/constants";
import { logEvents, smsWarningAlert } from "../../redux/commonActions";
import {
  PUBLIC_HEADER_DOWNLOAD_APP_CLICKED,
  PUBLIC_HEADER_DOWNLOAD_APP_SUBMIT,
  PUBLIC_HEADER_FEEDBACK_CLICKED,
  PUBLIC_HEADER_FEEDBACK_SUBMIT,
  PUBLIC_HEADER_LOGIN_CLICKED,
  PUBLIC_HEADER_LOOKING_FOR_JOB,
  PUBLIC_HB_CLICKED,
  PUBLIC_HB_DOWNLOAD_APP,
  PUBLIC_HB_FEEDBACK_CLICKED,
  FAQ_CLICKED,
  PUBLIC_HB_LOGIN_CLICKED,
  SIGN_OUT
} from "../../services/webengage/webEngageConstants";
import {
  LOGIN,
  PROFILE,
  HELP_CENTRE,
  Routes,
  FAQ
} from "../../routes/RouteConstants";
import CreditBalance from "../CreditBalance";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import CallCenter from "../../containers/HelpCenter/components/CallCenter";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import CommonEvents from "../../utils/commonEvents";

const CustomDrawer = dynamic(() => import("./Drawer"), {
  ssr: false
});

const HeaderDrawerContent = dynamic(() => import("./HeaderDrawer"), {
  ssr: false
});

const ResponsiveHeader = dynamic(() => import("./ResponsiveHeader"), {
  ssr: false
});

const HeaderList = dynamic(() => import("./HeaderList"), {
  ssr: false
});

const PostNewJobButton = dynamic(() => import("../PostNewJobButton"), {
  ssr: false
});

const Popover = dynamic(() => import("@material-ui/core/Popover"), {
  ssr: false
});

const styles = theme => ({
  root: {
    flexGrow: 1,
    position: "sticky",
    width: "100%",
    top: 0,
    zIndex: 10
  },
  rootNonFixed: {
    position: "inherit"
  },
  appBar: { boxShadow: "-1px 1px 0 2px #EBF0F2", padding: "0" },
  rootContainer: {
    margin: "0 5%",
    height: "6.438rem",
    alignItems: "center",
    ["@media (max-width:576px)"]: {
      margin: "0.625rem 0.313rem",
      height: "auto"
    }
  },
  title: {
    ...theme.typography.defaultFont,
    marginLeft: "1.25rem",
    marginTop: "0.625rem",
    ["@media (max-width:576px)"]: {
      fontSize: "0.625rem",
      lineHeight: "0.75rem"
    }
  },
  getAppNow: {
    color: "#2A89F6",
    marginLeft: "7px"
  },
  name: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1rem",
    marginLeft: "0.625rem",
    color: "#2E2E36"
  },
  loginBlueBtn: {
    ...theme.typography.defaultFont,
    fontWeight: 700,
    fontSize: "1.063rem",
    lineHeight: "1.313rem",
    color: "#2A89F6",
    marginLeft: "0.625rem"
  },
  giveFeedback: {
    ...theme.typography.defaultFont,
    fontWeight: 600,
    width: "99px"
  },
  flexCont: {
    ["@media (max-width:576px)"]: {
      maxWidth: "33%",
      flexBasis: "33%"
    },
    ["@media (min-width:576px)"]: {
      maxWidth: "22%",
      flexBasis: "22%"
    },
    ["@media (min-width:1200px)"]: {
      maxWidth: "27%",
      flexBasis: "27%"
    },
    ["@media (min-width:1500px)"]: {
      maxWidth: "35%",
      flexBasis: "35%"
    }
  },
  flex: { display: "flex" },
  menuCont: {
    border: "1px solid #E9ECF5",
    boxShadow: "0px 2px 5px rgba(1, 41, 75, 0.08)",
    borderRadius: "10px",
    width: "160px"
  },
  profileMenu: { ...theme.typography.defaultFont },
  buttomJS: {
    height: "2.75rem",
    borderRadius: "100px",
    textTransform: "none",
    backgroundColor: "#009688",
    marginLeft: "0.625rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#009688"
    },
    ["@media (max-width:576px)"]: {
      height: "1.75rem"
    }
  },
  buttonJSLabel: {
    ...theme.typography.defaultFont,
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: "0.875rem",
    padding: "0 0.625rem",
    textDecoration: "none",
    ["@media (max-width:576px)"]: {
      padding: "0.438rem",
      fontSize: "0.75rem",
      fontWeight: 600
    }
  },
  toolbar: {
    padding: "0",
    ["@media (max-width:576px)"]: {
      padding: "0 5px"
    }
  },
  faqMenu: {
    padding: "0.5rem",
    cursor: "pointer"
  },
  openIcon: {
    fontSize: "1.125rem",
    margin: "2px 0 0 5px",
    ["@media (max-width:576px)"]: {
      fontSize: "0.75rem"
    }
  },
  profileOpenIcon: {
    color: "#7D8394",
    fontSize: "0.938rem",
    margin: "4px 6px 0"
  },
  profilePic: {
    borderRadius: "50%",
    height: "2.5rem",
    width: "2.5rem",
    background: "#EBEFF4",
    border: "1px solid #D5E0EA"
  },
  picPadding: { paddingTop: "0.375rem" },
  arrow: {
    height: "1.875rem",
    width: "1.75rem",
    marginTop: "0.313rem"
  },
  desktop: {
    ...theme.typography.defaultFont,
    fontSize: "1.063rem",
    fontWeight: 700,
    lineHeight: "1.313rem",
    ["@media (max-width:769px)"]: { display: "none" }
  },
  tab: { ["@media (min-width:770px)"]: { display: "none" } },
  downApp: { display: "flex", alignItems: "center", cursor: "pointer" },
  buyContainer: {
    border: "1px solid #E2E8F0",
    borderRadius: "6px",
    padding: "4px 6px 4px 6px",

    ["@media (min-width:770px)"]: {
      borderRadius: "10px",
      padding: "4px 4px 4px 12px"
    }
  },
  buyCredits: {
    background: "#DBEAFE80",
    marginLeft: "10px",
    color: "#2563EB",
    fontWeight: "600",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "flex-end",
    padding: "6px 8px 6px 8px",
    fontSize: "16px"
  },
  callIcon: {
    width: "2.188rem",
    height: "2.188rem",
    borderRadius: "1.25rem",
    "& img": {
      marginRight: 0
    }
  },
  desktopRoot: {
    ["@media (min-width:770px)"]: {
      maxWidth: "40%"
    }
  },
  rootContainerMargin: {
    ["@media (min-width:770px)"]: {
      margin: "0 0 0 2rem"
    }
  }
});

class Header extends Component {
  state = {
    isGetAppOpen: false,
    isFeedbackOpen: false,
    anchorEl: null,
    error: "",
    mobileOpen: false,
    isCreditBetaUserLoggedin: false,
    creditProfileApiState: "LOADING",
    totalCredits: null
  };

  componentDidMount() {
    const { isLogin } = this.props;
    this.unsubscribe = useCreditProfileStore.subscribe(newState =>
      this.setState({
        isCreditBetaUserLoggedin: isLogin && newState.isCreditBetaUser,
        creditProfileApiState: newState.fetchedState,
        totalCredits: newState.totalAvailableCredits
      })
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  toggleDrawer =
    (type, open, isHBOpen = false) =>
    () => {
      if (open) {
        if (isHBOpen) {
          type === "isGetAppOpen"
            ? this.props.logEvents(PUBLIC_HB_DOWNLOAD_APP)
            : this.props.logEvents(PUBLIC_HB_FEEDBACK_CLICKED);
        } else {
          type === "isGetAppOpen"
            ? this.props.logEvents(PUBLIC_HEADER_DOWNLOAD_APP_CLICKED)
            : this.props.logEvents(PUBLIC_HEADER_FEEDBACK_CLICKED);
        }
      }
      if (type === "isGetAppOpen" && isHBOpen) {
        window.open(RECRUITER_ANDROID_APP, "_blank");
        this.setState({
          error: "",
          mobileOpen: false
        });
      } else {
        this.setState({
          [type]: open,
          error: "",
          mobileOpen: false
        });
      }
    };

  helpCenterOnClick = (isHBOpen = false) => {
    const eventName = isHBOpen
      ? PUBLIC_HB_FEEDBACK_CLICKED
      : PUBLIC_HEADER_FEEDBACK_CLICKED;
    this.props.logEvents(eventName);
    if (isHBOpen) {
      this.setState({
        mobileOpen: false
      });
    }
    if (!window.location.pathname.includes(HELP_CENTRE))
      window.open(`${process.env.LIVE_URL_HIRE}/${HELP_CENTRE}`, "__blank");
  };

  isEmpty = obj => Object.keys(obj).length === 0;

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  openLogIn = () => {
    this.props.logEvents(PUBLIC_HEADER_LOGIN_CLICKED);
    window.open(`/hire${LOGIN}`, "_blank");
  };

  handleLookingForJob = () => {
    this.props.logEvents(PUBLIC_HEADER_LOOKING_FOR_JOB);
    window.location = recruiterToSeekerUTM();
  };

  onViewProfile = () => {
    LogService.log(CommonEvents.NAV_VIEW_PROFILE);
    window.open(`/hire${PROFILE}`, "_blank");
  };

  onSignOut = () => {
    const { logEvents } = this.props;
    this.props.logout(() => {
      logEvents(SIGN_OUT);
    });
  };

  onButtonClick = (event, type, inputValue) => {
    if (inputValue && !(type === "isGetAppOpen" && inputValue.length !== 10)) {
      type === "isGetAppOpen"
        ? this.sendDownloadAppLink(inputValue)
        : this.props.giveFeedback(inputValue);
      this.setState({
        [type]: false
      });
      type === "isGetAppOpen"
        ? this.props.logEvents(PUBLIC_HEADER_DOWNLOAD_APP_SUBMIT, {
            phone: inputValue
          })
        : this.props.logEvents(PUBLIC_HEADER_FEEDBACK_SUBMIT, {
            message: inputValue
          });
    } else {
      this.setState({
        error:
          type === "isGetAppOpen"
            ? "Please enter correct Mobile Number"
            : "Please enter feedback"
      });
    }
  };

  sendAppLink = () => {
    const { profileState } = this.props;
    const phone =
      profileState.payload.data && profileState.payload.data.phone
        ? profileState.payload.data.phone
        : "";
    this.props.logEvents(PUBLIC_HEADER_DOWNLOAD_APP_CLICKED, { phone: phone });
    if (phone) this.sendDownloadAppLink(phone);
  };

  sendDownloadAppLink = phone => {
    const { sendAppLink, smsWarningAlert } = this.props;
    if (allowSendAppLink()) sendAppLink(phone);
    else smsWarningAlert(phone);
  };

  handleNavBarToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    this.props.logEvents(PUBLIC_HB_CLICKED);
  };

  faqClick = () => {
    this.props.logEvents(FAQ_CLICKED);
    this.setState({ mobileOpen: false });
    if (!window.location.pathname.includes("recruiter-faqs"))
      window.open(`/hire${FAQ}`, "_blank");
  };

  handleCreateAccount = () => {
    this.props.logEvents(PUBLIC_HB_LOGIN_CLICKED);
    this.setState({ mobileOpen: false });
    window.open(`/hire${LOGIN}`, "_blank");
  };

  renderLookingtoHire = () => {
    const { classes } = this.props;
    return (
      <Grid item>
        <Button className={classes.buttomJS}>
          <span
            className={classes.buttonJSLabel}
            onClick={this.handleLookingForJob}
          >
            <Grid container alignItems="center">
              <Grid item>Looking for a job?</Grid>
              <Grid item>
                <img
                  className={classes.openIcon}
                  src={"/hire/open_new.svg"}
                  height="13px"
                  width="13px"
                  alt="hire staff"
                />
              </Grid>
            </Grid>
          </span>
        </Button>
      </Grid>
    );
  };

  renderViewProfile = () => {
    const { classes } = this.props;
    return (
      <Grid container alignItems="center">
        <Grid item>View Profile</Grid>
        <Grid item>
          <img
            className={classes.profileOpenIcon}
            src={"/hire/open_new_black.svg"}
            height="13.5px"
            width="13.5px"
            alt="hire staff"
          />
        </Grid>
      </Grid>
    );
  };

  renderDesktopHeader = () => {
    const {
      classes,
      profileData = {},
      isPostNewJob,
      pathname,
      isLogin,
      logoutOnly
    } = this.props;
    const { anchorEl, isCreditBetaUserLoggedin, totalCredits } = this.state;
    const { full_name = "", image_url = "" } = profileData;
    const firstName = full_name ? getFirstWord(full_name) : "";
    return (
      <div className={classes.desktop}>
        <Grid container justify="space-evenly" alignItems="center">
          <Grid item>
            {!logoutOnly && !isCreditBetaUserLoggedin ? (
              <div
                onClick={
                  isLogin
                    ? this.sendAppLink
                    : this.toggleDrawer("isGetAppOpen", true)
                }
                className={classes.downApp}
              >
                <img
                  src="/hire/import-icon.svg"
                  width="25px"
                  height="25px"
                  alt="download"
                />
                <span className={classes.getAppNow}>Download App</span>
              </div>
            ) : null}
          </Grid>
          {logoutOnly ? (
            <Grid item></Grid>
          ) : !isCreditBetaUserLoggedin ? (
            <Grid item className={classes.faqMenu} onClick={this.faqClick}>
              FAQs
            </Grid>
          ) : null}
          {!isLogin ? (
            <>
              {pathname !== "/recruiter-login" ? (
                <Grid item>
                  <Button onClick={this.openLogIn}>
                    <IconText
                      src="/hire/person_blue.svg"
                      width="16px"
                      height="16px"
                      alt="person"
                    >
                      <span className={classes.loginBlueBtn}>Login</span>
                    </IconText>
                  </Button>
                </Grid>
              ) : null}
              {this.renderLookingtoHire()}
            </>
          ) : (
            <>
              {isLogin && isPostNewJob ? (
                <Grid item>
                  <PostNewJobButton view={"view2"} />
                </Grid>
              ) : null}
              {isCreditBetaUserLoggedin ? (
                <div
                  className={classNames(
                    classes.buyContainer,
                    "flex flex-row items-center"
                  )}
                >
                  <CreditBalance view={"view3"} />
                </div>
              ) : null}

              {pathname !== PROFILE && (
                <Grid item>
                  {isLogin ? (
                    <Grid
                      container
                      alignItems="center"
                      onClick={this.handleClick}
                      id="profile-dropdown"
                    >
                      {image_url ? (
                        <img
                          className={classes.profilePic}
                          src={image_url}
                          alt="profile picture"
                        />
                      ) : (
                        <img
                          className={classNames(
                            classes.profilePic,
                            classes.picPadding
                          )}
                          src={"/hire/placeholder.svg"}
                          alt="profile picture"
                        />
                      )}
                      <Grid item className={classes.name}>
                        {firstName}
                      </Grid>
                      <Grid item>
                        <img
                          src="/hire/arrow_down.svg"
                          className={classes.arrow}
                          alt="arrow"
                        />
                      </Grid>
                    </Grid>
                  ) : null}
                  <Popover
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    classes={{ paper: classes.menuCont }}
                    style={{ top: 8, left: -8 }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right"
                    }}
                  >
                    {pathname !== PROFILE && !logoutOnly ? (
                      <MenuItem
                        onClick={this.onViewProfile}
                        className={classes.profileMenu}
                      >
                        {this.renderViewProfile()}
                      </MenuItem>
                    ) : null}
                    <MenuItem
                      onClick={this.helpCenterOnClick}
                      className={classes.profileMenu}
                    >
                      Help Center
                    </MenuItem>
                    <MenuItem
                      onClick={this.onSignOut}
                      className={classes.profileMenu}
                    >
                      Log Out{" "}
                    </MenuItem>
                  </Popover>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </div>
    );
  };

  render() {
    const {
      classes,
      profileState,
      profileData = {},
      isPostNewJob,
      pathname,
      onlyLogo,
      isHeaderFixed,
      isLogin,
      isClick,
      logoutOnly,
      deviceType,
      headerMargin
    } = this.props;
    const isMobile = deviceType === "mobile";
    const {
      isGetAppOpen,
      isFeedbackOpen,
      anchorEl,
      error,
      mobileOpen,
      creditProfileApiState,
      isCreditBetaUserLoggedin
    } = this.state;
    const { full_name = "", image_url = "" } = profileData;
    const firstName = full_name ? getFirstWord(full_name) : "";
    const drawrType = isGetAppOpen ? "isGetAppOpen" : "isFeedbackOpen";
    return (
      <>
        <div
          id="header-root"
          className={
            isHeaderFixed
              ? classes.root
              : classNames(classes.root, classes.rootNonFixed)
          }
        >
          <AppBar position="static" color="inherit" className={classes.appBar}>
            <Toolbar variant="dense" className={classes.toolbar}>
              <Grid
                container
                justify="space-between"
                className={
                  headerMargin
                    ? classNames(
                        classes.rootContainer,
                        classes.rootContainerMargin
                      )
                    : classes.rootContainer
                }
              >
                <Grid item className={classes.flexCont}>
                  <div className={classes.flex}>
                    <Logo isClick={isClick} isBack={pathname == PROFILE} />
                  </div>
                </Grid>
                {!onlyLogo ? (
                  <Grid className={classes.desktopRoot} item xs>
                    {!isMobile &&
                    ((isLogin && creditProfileApiState === "SUCCESS") ||
                      !isLogin)
                      ? this.renderDesktopHeader()
                      : null}
                    {isMobile ? (
                      <div className={classes.tab}>
                        <Grid container justify="flex-end" alignItems="center">
                          {!isLogin ? this.renderLookingtoHire() : null}
                          {pathname === Routes.TRANSACTION_HISTORY ? (
                            <CallCenter
                              customClass={classes.callIcon}
                              iconOnly
                            />
                          ) : isCreditBetaUserLoggedin ? (
                            <div className={classes.buyContainer}>
                              <CreditBalance view={"view3"} />
                            </div>
                          ) : null}

                          <Grid item>
                            <IconButton onClick={this.handleNavBarToggle}>
                              <img
                                src="/hire/menu-icon.svg"
                                height={24}
                                width={24}
                                alt="hamburger menu icon"
                              />
                            </IconButton>
                          </Grid>
                        </Grid>
                        <ResponsiveHeader
                          mobileOpen={mobileOpen}
                          handleNavBarToggle={this.handleNavBarToggle}
                          headerList={
                            <HeaderList
                              isLogin={isLogin}
                              isPostNewJob={isPostNewJob}
                              profileData={profileData}
                              toggleDrawer={this.toggleDrawer}
                              onViewProfile={this.onViewProfile}
                              renderViewProfile={this.renderViewProfile}
                              onSignOut={this.onSignOut}
                              faqClick={this.faqClick}
                              handleCreateAccount={this.handleCreateAccount}
                              helpCenterOnClick={this.helpCenterOnClick}
                              pathname={pathname}
                              isCreditBetaUserLoggedin={
                                isCreditBetaUserLoggedin
                              }
                              logoutOnly={logoutOnly}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </Grid>
                ) : null}
              </Grid>
            </Toolbar>
          </AppBar>
          <CustomDrawer
            isOpen={isGetAppOpen || isFeedbackOpen}
            toggleDrawer={this.toggleDrawer}
            type={drawrType}
            anchor={detectMobile() ? "bottom" : "top"}
          >
            <HeaderDrawerContent
              onButtonClick={this.onButtonClick}
              toggleDrawer={this.toggleDrawer}
              type={drawrType}
              error={error}
            />
          </CustomDrawer>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loginState: state.loginReducer,
  profileState: state.userProfileReducer,
  profileData: state.userProfileReducer.payload.data,
  deviceType: state.commonReducer.deviceType
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logout,
      sendAppLink,
      giveFeedback,
      logEvents,
      smsWarningAlert
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Header));
